import React from "react";
import { TBook } from "../resources/types"

export const CorpusContext = React.createContext<TBook[]>([])
